import { useState, useEffect } from 'react'
import {
  usersByOrg,
  usersQuitBySwr,
  editUser,
  resetUserPwd,
  activeUser as activeUserApi,
  inactiveUser,
  changeOrgBatch,
  changeRoleBatch,
} from '@vt/apis/lib-ex/v2/users'
// import UsersContext from './context'
// import OrgContext from '../org/context'

// 搜索用户
const filterBySearchData = function (obj, query) {
  return (
    (obj.name || '').indexOf(query) > -1 ||
    (obj.username || '').indexOf(query) > -1 ||
    (obj.mobile || '').indexOf(query) > -1
  )
}

const useUsers = function (appId, currentOrg, currentGroup, searchData) {
  // const { users, resignedUsers, fetchUsers } = useContext(UsersContext) || {}
  const { orgUsers: users, orgUsersMutate: fetchUsers } = usersByOrg(appId)
  // 已离职的用户
  const { resignedUsers } = usersQuitBySwr(appId)

  const [showUsers, setShowUsers] = useState(users || [])
  const [checkedUsers, setCheckedUsers] = useState([])

  // 通过分组筛选用户，除已离职 都用filter获取
  const filterUsersByGroup = () => {
    if (currentGroup === 'unApproved') {
      // 待审批
      setShowUsers(
        (users || []).filter((obj) => {
          return obj.status === '0' && filterBySearchData(obj, searchData)
        })
      )
    }
    if (currentGroup === 'disabled') {
      // 已禁用
      setShowUsers(
        (users || []).filter((obj) => {
          return obj.active === false && filterBySearchData(obj, searchData)
        })
      )
    }
    if (currentGroup === 'resigned') {
      // 已离职
      setShowUsers(resignedUsers.data || [])
    }
    if (currentGroup === 'all') {
      // 全部组织
      setShowUsers(
        (users || []).filter((obj) => {
          return obj.active && filterBySearchData(obj, searchData)
        })
      )
    }
    if (currentGroup === 'unActive') {
      setShowUsers(
        (users || []).filter((obj) => {
          return obj.status === '-1' && filterBySearchData(obj, searchData)
        })
      )
    }
    return { users: [] }
  }

  // 通过组织筛选用户
  const filterUsersByOrg = () => {
    // 组织下的用户显示忽略搜索框数据
    setShowUsers(
      (users || []).filter((obj) => {
        return (
          obj.orgId === Number(currentOrg.key) &&
          obj.active &&
          obj.status === '1' &&
          filterBySearchData(obj, searchData)
        )
      })
    )
  }

  const onCheckedUsers = (objs) => {
    if (objs.length > 0) {
      setCheckedUsers(objs)
    } else if (checkedUsers.length > 0) {
      setCheckedUsers([])
    }
  }

  // 用户操作相关
  // 编辑用户
  const updateUser = (data, afterUpdate) => {
    return editUser(appId, data).then(() => {
      fetchUsers()
      if (afterUpdate) {
        afterUpdate()
      }
    })
  }

  // 新增用户

  // 禁用
  const disableUser = (ids, afterDisable) => {
    return inactiveUser(appId, ids).then(() => {
      fetchUsers()
      if (afterDisable) {
        afterDisable()
      }
    })
  }

  // 启用
  const activeUser = (ids, afterActive) => {
    return activeUserApi(appId, ids).then(() => {
      fetchUsers()
      if (afterActive) {
        afterActive()
      }
    })
  }

  // 更新密码
  const updatePwd = (userId, password, afterUpdate) => {
    return resetUserPwd(appId, userId, password).then(() => {
      if (afterUpdate) {
        afterUpdate()
      }
    })
  }

  // 删除用户
  // 审批通过
  // 审批拒绝
  // 用户交接

  // 转移部门
  const changeOrg = (userIds, orgId, afterChange) => {
    return changeOrgBatch(appId, userIds, orgId).then(() => {
      fetchUsers()
      if (afterChange) {
        afterChange()
      }
    })
  }

  // 配置角色
  const configRole = (userIds, roleId, afterConfig) => {
    return changeRoleBatch(appId, userIds, roleId).then(() => {
      fetchUsers()
      if (afterConfig) {
        afterConfig()
      }
    })
  }

  // 更新要展示的用户列表
  useEffect(() => {
    if (currentGroup) {
      filterUsersByGroup()
    } else if (currentOrg) {
      filterUsersByOrg()
    }
  }, [users, currentGroup, currentOrg, searchData])

  return {
    showUsers,
    checkedUsers,
    fetchUsers,
    onCheckedUsers,
    userOperate: {
      updateUser,
      activeUser,
      disableUser,
      updatePwd,
      changeOrg,
      configRole,
    },
  }
}

export default useUsers
